import React, { useEffect, useState, useContext } from 'react';
import httpInjectorService from '../../services/http-injector.service';
import {
  Card,
  Row,
  Col,
  Typography,
  Switch,
  Spin,
  message,
  Tag,
  Avatar,
  Space,
  Empty,
} from 'antd';
import {
  AppstoreOutlined,
  QuestionCircleOutlined,
  MailOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
} from '@ant-design/icons';
import { NotificationContext } from '../../NotificationProvider';

const { Title, Text, Paragraph } = Typography;

const HelpandSupport = () => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingId, setUpdatingId] = useState(null);
  const { openNotification } = useContext(NotificationContext);

  useEffect(() => {
    fetchFeatures();
  }, []);

  const fetchFeatures = async () => {
    setLoading(true);
    try {
      const res = await httpInjectorService.getFeatures();
      console.log(res, "ressss")
      setFeatures(res.data);
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false);
    }
  };

  // const toggleFeature = async (id, currentStatus) => {
  //   console.log(currentStatus, "currentststaus")
  //   console.log(id, "Iddd")
  //   setUpdatingId(id);
  //   try {
  //     let data = {
  //       feature_id: id,
  //       is_active: currentStatus ? 1 : 0,
  //     }
  //     let res = await httpInjectorService.updateFeatureStatus(data);
  //     if (res.status === "SUCCESS") {
  //       setFeatures((prev) =>
  //         prev.map((f) => (f.feature_id === id ? { ...f, is_active: !currentStatus } : f))
  //       );
  //       openNotification("success", res.message);
  //     } else {
  //       openNotification("failure", res.message);
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   } finally {
  //     setUpdatingId(null);
  //   }
  // };

  const toggleFeature = async (id, checked) => {
  setUpdatingId(id);

  try {
    const data = {
      feature_id: id,
      is_active: checked ? 1 : 0,
    };

    const res = await httpInjectorService.updateFeatureStatus(data);

    if (res.status === "SUCCESS") {
      setFeatures((prev) =>
        prev.map((f) =>
          f.feature_id === id
            ? { ...f, is_active: checked } // <-- use checked, don't invert
            : f
        )
      );

      openNotification("success", res.message);
    } else {
      openNotification("failure", res.message);
    }
  } catch (err) {
    console.log(err);
  } finally {
    setUpdatingId(null);
  }
};
  return (
    <div className="help-support-page">
      <Card
        bordered
        style={{
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          width: '100%',
          minHeight: '600px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          background: '#fafafa',
        }}
        bodyStyle={{
          padding: '20px',
          overflowY: 'auto',
          flex: 1,
        }}
      >
        <Row gutter={[16, 16]}>
          {/* Left: Features */}
          <Col xs={24} md={12}>
            <Card
              size="small"
              style={{
                borderRadius: '14px',
                height: '100%',
                border: '1px solid #f0f0f0',
                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
              }}
              bodyStyle={{ padding: '16px', maxHeight: '340px', overflowY: 'auto' }}
              title={
                <Space>
                  <Avatar
                    size={28}
                    icon={<AppstoreOutlined />}
                    style={{ backgroundColor: '#0D2481' }}
                  />
                  <span>Features</span>
                </Space>
              }
            >
              {loading ? (
                <div style={{ textAlign: 'center', padding: '24px 0' }}>
                  <Spin />
                </div>
              ) : features.length === 0 ? (
                <Empty description="No features found" />
              ) : (
                features.map((feature) => (
                  <div
                    key={feature.featur_id}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '10px 12px',
                      marginBottom: 10,
                      borderRadius: '10px',
                      background: '#fff',
                      border: '1px solid #f0f0f0',
                      transition: 'all 0.2s ease',
                    }}
                    className="feature-row"
                  >
                    <Space size={10}>
                      {feature.is_active ? (
                        <CheckCircleFilled style={{ color: '#52c41a', fontSize: 16 }} />
                      ) : (
                        <CloseCircleFilled style={{ color: '#d9d9d9', fontSize: 16 }} />
                      )}
                      <div>
                        <Text strong style={{ display: 'block', fontSize: 13 }}>
                          {feature.feature_name}
                        </Text>
                        <Tag
                          color={feature.is_active ? 'green' : 'default'}
                          style={{ marginTop: 2, fontSize: 11, lineHeight: '16px' }}
                        >
                          {feature.is_active ? 'Active' : 'Inactive'}
                        </Tag>
                      </div>
                    </Space>

                    <Switch
                      size="small"
                      checked={feature.is_active}
                      loading={updatingId === feature.feature_id}
                      onChange={(checked) =>
                        toggleFeature(feature.feature_id, checked)
                      }
                    />
                  </div>
                ))
              )}
            </Card>
          </Col>

          {/* Right: FAQ + Contact */}
          <Col xs={24} md={12}>
            <Card
              size="small"
              style={{
                borderRadius: '14px',
                height: '100%',
                border: '1px solid #f0f0f0',
                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
              }}
              bodyStyle={{ padding: '16px' }}
              title={
                <Space>
                  <Avatar
                    size={28}
                    icon={<QuestionCircleOutlined />}
                    style={{ backgroundColor: '#0D2481' }}
                  />
                  <span>FAQs & Support</span>
                </Space>
              }
            >
              <div style={{ marginBottom: 20 }}>
                <Title level={5} style={{ marginTop: 0, marginBottom: 4 }}>
                  FAQs
                </Title>
                <Paragraph type="secondary" style={{ marginBottom: 0, fontSize: 13 }}>
                  Find answers to common questions about our services.
                </Paragraph>
              </div>

              <div
                className="support-contact-card"
                style={{
                  background: '#fff',
                  border: '1px solid #f0f0f0',
                  borderRadius: '10px',
                  padding: '12px 14px',
                }}
              >
                <Space>
                  <Avatar size={28} icon={<MailOutlined />} style={{ backgroundColor: '#fa8c16' }} />
                  <div>
                    <Text strong style={{ display: 'block', fontSize: 13 }}>
                      Contact Support
                    </Text>
                    <Text type="secondary" style={{ fontSize: 13 }}>
                      info@nubaxdatalabs.com
                    </Text>
                  </div>
                </Space>
              </div>
            </Card>
          </Col>
        </Row>
      </Card>

      <style>{`
        .feature-row:hover {
          border-color: #1677ff !important;
          box-shadow: 0 2px 6px rgb(13, 36, 129);
        }
      `}</style>
    </div>
  );
};

export default HelpandSupport;
